var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 4.97379915e-14 100 4.97379915e-14 100 94.9992 0 94.9992"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(50.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,41.5 C31.416,41.5 28.5,38.584 28.5,35 C28.5,31.416 31.416,28.5 35,28.5 C38.584,28.5 41.5,31.416 41.5,35 C41.5,38.584 38.584,41.5 35,41.5 M35,22 C27.832,22 22,27.832 22,35 C22,42.168 27.832,48 35,48 C42.168,48 48,42.168 48,35 C48,27.832 42.168,22 35,22",
    id: "Fill-1",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,87.1152 L64.372,55.7772 C63.77,55.1352 62.932,54.7632 62.052,54.7492 C61.154,54.7192 60.324,55.0772 59.702,55.7012 L45.586,69.8192 L35.802,63.2952 C34.554,62.4652 32.9,62.5912 31.794,63.6112 L6.25,87.1912 L6.25,6.9272 C6.25,6.3812 6.716,5.9372 7.292,5.9372 L92.708,5.9372 C93.284,5.9372 93.75,6.3812 93.75,6.9272 L93.75,87.1152 Z M13.808,89.0632 L34.324,70.1232 L44.198,76.7052 C45.492,77.5652 47.206,77.3932 48.298,76.2992 L61.924,62.6712 L86.666,89.0632 L13.808,89.0632 Z M92.708,-0.0008 L7.292,-0.0008 C3.272,-0.0008 0,3.1072 0,6.9272 L0,88.0732 C0,91.8932 3.272,94.9992 7.292,94.9992 L92.708,94.9992 C96.728,94.9992 100,91.8932 100,88.0732 L100,6.9272 C100,3.1072 96.728,-0.0008 92.708,-0.0008 L92.708,-0.0008 Z",
    id: "Fill-3",
    fill: "#999999",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "img-placeholder.4f7f576c65ef85bd0fd073908be9ab43.svg";
export { ForwardRef as ReactComponent };